"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Constant = require("../Constant");

var _Text = require("../Text");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  align-items: center;\n  color: ", ";\n  font-weight: 800;\n  letter-spacing: normal;\n  text-align: center;\n  line-height: 1.4;\n  margin-bottom: 0;\n\n  &:hover {\n    text-decoration-color: currentcolor;\n    text-decoration-line: underline;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 45px;\n  height: 48px;\n  background-color: ", ";\n  cursor: ", ";\n\n  @media print, screen and (max-width: ", "px) {\n    padding: 0 30px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// TODO: Banner component needs to be keyboard focusable and needs focus styles.
var BannerContainer = _styledComponents.default.div.attrs({
  className: 'banner'
})(_templateObject(), _Constant.Color.LIGHT_GREY_PURPLE, function (props) {
  return props.isClickable ? 'pointer' : 'initial';
}, _Constant.Width.MD - 1);

var BannerMessage = (0, _styledComponents.default)(_Text.SecondaryH4)(_templateObject2(), _Constant.Color.LIGHT_PURPLE);

var Banner = function Banner(_ref) {
  var renderMessage = _ref.renderMessage,
      renderModal = _ref.renderModal,
      handleClick = _ref.handleClick;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(BannerContainer, {
    onClick: handleClick,
    isClickable: renderModal
  }, /*#__PURE__*/_react.default.createElement(BannerMessage, null, renderMessage)), renderModal);
};

Banner.propTypes = {
  renderMessage: _propTypes.default.node.isRequired,
  renderModal: _propTypes.default.node,
  handleClick: _propTypes.default.func
};
Banner.defaultProps = {
  renderModal: null,
  handleClick: function handleClick() {
    return null;
  }
};
var _default = Banner;
exports.default = _default;